import Vue from 'vue';
import App from './App.vue';
import VueRouter from 'vue-router';
import store from './store/index.js';
import { commonHelper } from './common-helper';
import axios from 'axios';
import { ApiManager } from './api-manager';
import 'bootstrap/dist/css/bootstrap.css';
import vuetify from './plugins/vuetify';
import VueApexCharts from 'vue-apexcharts';

Vue.use(VueApexCharts)

Vue.component('apex-chart', VueApexCharts);

Vue.config.ignoredElements = [/^ion-/];
//axios
const axiosInstance = axios.create({
  baseURL: process.env.VUE_APP_API_URL,
  headers: {
    'Content-Type': 'multipart/form-data'
  }
});

//globally
window.$axios = axiosInstance;
Vue.prototype.$api = new ApiManager();

axiosInstance.interceptors.request.use(function (config) {
  config.headers = {
    "Authorization": `jwt ${store.state.token}`
  }
  return config;
}, function (error) {
  return Promise.reject(error);
});


Vue.config.productionTip = false;
Vue.use(VueRouter);
Vue.prototype.$commonHelper = commonHelper;

const router = new VueRouter({
  mode: 'history'
});

new Vue({
  vuetify,
  render: h => h(App),
  router,
  store
}).$mount('#app') 